module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Regular.woff2?74024a82febaec33e993763228a409f9";